function TextApplication() {

}


TextApplication.events = {
    isInit: true,

    init: function() {
        var self = this;
        var parent = $("#primary_options_container");

        if (self.isInit) {    
            $(parent).on("keypress", ".application-container input.application-name", self.onChangeText);
            $(parent).on("blur", ".application-container input.application-name", self.onBlurText);
            $(parent).on("click", ".application-container .select-font-style", self.onSelectFont);
            $(parent).on("click", ".application-container .change-font", self.onChangeFont);
            $(parent).on("click", ".application-container .select-layout-style", self.onSelectLayout);
            $(parent).on("click", ".application-container .change-layout", self.onChangeLayout);
            $(parent).on("click", ".application-container .change-angle", self.changeApplicationAngle);
            $(parent).on("click", ".application-container .application-color-menu-button", self.onSwitchApplicationMenu);
            $(parent).on("click", ".application-container .select-accent", self.onSelectAccent);
            $(parent).on("click", ".application-container .change-color", self.onChangeColor);
            $(parent).on("click", ".application-container .edit-team-colors", self.onEdit);

            $(parent).on("click", ".application-container .select-pattern", self.onSelectPattern);
            $(parent).on("click", ".application-container .select-mascot", self.onSelectMascot);
            $(parent).on("click", ".application-container .edit-pattern-mascot", self.editPatternMascot);
            $(parent).on("change", ".application-container .change-pattern-layout", self.changePatternLayout);
            $(parent).on("click", ".application-container .change-pattern-color", self.onChangePatternColor);

            $(parent).on("click", ".application-container .edit-pattern-logo", self.editPatternMascot);
            $(parent).on("click", ".application-container .show-pattern-mascot-modal", self.onSelectMascot);


            self.isInit = false;
        }
    },

    onChangeText: function(e) {
        var application_code = $(this).closest(".application-container").data("application-code");
        var applicationSettings = ub.funcs.getApplicationSettings(application_code);
        var value = $(this).val();

        if (value.length !== 0) {
            if (e.keyCode === 13) {
                if (value === applicationSettings.text) {
                    return;
                }
                
                if (TextShapeCore.utilities.isTextShape(applicationSettings.code)) {
                    if (applicationSettings.text_shape_type === "arc") {
                        TextShapeCore.customControllers.changeArcText(applicationSettings, value);
                    }
                    TextShapeCore.funcs.changeText(applicationSettings, value);
                } else {
                    ApplicationCore.funcs.changeText(value, applicationSettings);
                }
            }
        }
    },

    onBlurText: function() {
        var application_code = $(this).closest(".application-container").data("application-code");
        var applicationSettings = ub.funcs.getApplicationSettings(application_code);
        var value = $(this).val();

        if (value === applicationSettings.text) {
            return;
        }

        if (value.length !== 0) {
            if (TextShapeCore.utilities.isTextShape(applicationSettings.code)) {
                if (applicationSettings.text_shape_type === "arc") {
                    TextShapeCore.customControllers.changeArcText(applicationSettings, value);
                }
                TextShapeCore.funcs.changeText(applicationSettings, value);
            } else {
                ApplicationCore.funcs.changeText(value, applicationSettings);
            }
        }
    },

    onSelectFont: function() {
        var application_code = $(this).closest(".application-container").data("application-code");
        var applicationSettings = ub.funcs.getApplicationSettings(application_code);
        var sampleText = $(this).closest(".application-container").find("input.application-name").val();

        FontModal.funcs.loadFontModal(sampleText, applicationSettings);
    },

    onChangeFont: function() {
        var application_code = $(this).closest(".application-container").data("application-code");
        var applicationSettings = ub.funcs.getApplicationSettings(application_code);
        var _direction = $(this).data('direction');
        var _newFont = ub.funcs.getFontObj(_direction, applicationSettings.font_obj);

        if (TextShapeCore.utilities.isTextShape(applicationSettings.code)) {
            if (application.text_shape_type === "arc") {
                TextShapeCore.customControllers.changeTextArcFontStyle(application_code, _direction);
            }
            TextShapeCore.funcs.changeFont(applicationSettings.code, _direction);
        } else {
            if (typeof _newFont !== 'undefined') {
                ub.funcs.changeFontFromPopup(_newFont.id, applicationSettings);
                ub.funcs.activateApplications(applicationSettings.code)
            } else {
                // No Font!
                return;
            }

            if (applicationSettings.type === "front_number" || applicationSettings.type === "back_number") {
                _.each (ub.current_material.settings.applications, function (_application) {
                    if (_application.type !== applicationSettings.application_type && _application.type !== "logo" && _application.type !== "mascot") {
                        if (applicationSettings.type.indexOf('number') !== -1 && _application.type.indexOf('number') !== -1) {
                            ub.funcs.changeFontFromPopup(_newFont.id, _application);
                        }
                    } 
                });
            }

            var _matchingID = undefined;
        
            _matchingID = ub.data.matchingIDs.getMatchingID(application_code);

            if (typeof _matchingID !== "undefined") {
                var _matchingSettingsObject     = _.find(ub.current_material.settings.applications, {code: _matchingID.toString()});
                ub.funcs.changeFontFromPopup(_newFont.id, _matchingSettingsObject);
            }
        }
    },

    onSelectLayout: function() {
        var application_code = $(this).closest(".application-container").data("application-code");
        var applicationSettings = ub.funcs.getApplicationSettings(application_code);

        var app_type = applicationSettings.type;
        var application_type = applicationSettings.application_type;
        var current_layout = "none";

        if (TextShapeCore.utilities.isTextShape(applicationSettings.code)) {
            app_type = applicationSettings.textLayoutType;
            application_type = applicationSettings.textLayoutType;
            current_layout = applicationSettings.text_shape_type
        }

        var type = app_type.replace("_", " ");

        TextShapeModal.funcs.loadTextShapeModal(application_code, type, current_layout, application_type);
    },

    onChangeLayout: function() {
        var application_code = $(this).closest(".application-container").data("application-code");
        var applicationSettings = ub.funcs.getApplicationSettings(application_code);
        var direction = $(this).data("direction");
        var current_layout = $(".application-container a.select-layout-style").data("layout");
        var textShapes = ub.data.textShapes.items;

        var current_type_key = textShapes.indexOf(current_layout);

        switch(direction) {
            case TextShapeCore.TEXT_SHAPE_LAYOUT_NEXT_TEXT:
                current_type_key++;
                break;

            case TextShapeCore.TEXT_SHAPE_LAYOUT_PREVIOUS_TEXT:
                current_type_key--;
                break;
        }

        if (current_type_key < 0) {
            current_type_key = 0;
        } else if (current_type_key > (textShapes.length-1)) {
            current_type_key = textShapes-1;
        } else {
            var new_layout = textShapes[current_type_key];
            $("span.layout-name").data("layout", new_layout);
            $("span.layout-name").text(new_layout);

            if (new_layout === "arc") {
                TextShapeCore.customControllers.renderARC(applicationSettings, new_layout);
            } else {
            if (applicationSettings.application_type !== TextShapeCore.TEXT_SHAPE_TYPE) {
                TextShapeCore.funcs.addTextShapeConfiguration(applicationSettings, new_layout);
            } else {
                TextShapeCore.funcs.changeTextShape(applicationSettings, new_layout);
            }
        }
        }
    },

    changeApplicationAngle: function() {
        var application_code = $(this).closest(".application-container").data("application-code");
        var applicationSettings = ub.funcs.getApplicationSettings(application_code);
        var _angle = $(this).data("angle");
        var rotation = _angle === "rotated" ? ub.data.rotatedValue : 0;
        applicationSettings.angle = _angle;

        ApplicationCore.utilities.rotateApplication(rotation, applicationSettings.code);

        $(".application-container .angle-items").find("a.uk-active").removeClass("uk-active");
        $(this).addClass("uk-active");
    },

    onSwitchApplicationMenu: function() {
        if ($(this).parent().hasClass("uk-active")) {
            return;
        }

        var application_code = $(this).closest(".application-container").data("application-code");
        var applicationSettings = ub.funcs.getApplicationSettings(application_code);

        var tabType = $(this).data("type");
        var stockFactoryCode = ['HCM', 'QTS', 'MDJ'];

        if (tabType === "colors") {
            ApplicationCore.view.renderColors(applicationSettings);
            if (_.contains(stockFactoryCode, ub.current_material.material.factory_code)) {
                $('div#edit-team-colors').removeClass('uk-hidden');
            }
        } else if (tabType === "pattern") {
            ApplicationCore.view.renderPattern(applicationSettings);
        } else if (tabType === "mascot") {
            ApplicationCore.view.renderMascot(applicationSettings);
        } else {
            return;
        }

        $(".application-menu-switcher li.uk-active").removeClass("uk-active");
        $(this).parent().addClass("uk-active")
    },

    onSelectAccent: function() {
        var application_code = $(this).closest(".application-container").data("application-code");
        var applicationSettings = ub.funcs.getApplicationSettings(application_code);
        ub.funcs.createAccentPopup(applicationSettings);
    },

    onChangeColor: function() {
        var that = this;
        var container = $(this).closest(".layer-container");
        var layer_number = $(container).data("layer-number");
        var layer_name = $(container).data("layer-name");
        var color_code = $(this).data("color-code");
        var color_object = ub.funcs.getColorByColorCode(color_code);
        var application_code = $(this).closest(".application-container").data("application-code");

        $(container).find("a.uk-active").removeClass("uk-active").html("");

        ApplicationCore.funcs.changeTextApplicationColor(application_code, layer_number, layer_name, color_object, function() {
            $(that).addClass("uk-active");
            $(that).html('<span class="fa fa-check fa-1x color-pallete-check" style="color: #'+ color_object.forecolor +'"></span>');
        });
    },

    onEdit: function() {
        ub.funcs.activateTeamColors();
    },

    onSelectPattern: function() {
        var application_code = $(this).closest(".application-container").data("application-code");
        var applicationSettings = ub.funcs.getApplicationSettings(application_code);
        ProlookPattern.events.showApplicationPatternModal(applicationSettings);
    },

    onChangePatternColor: function() {
        var that = this;
        var application_code = $(this).closest(".application-container").data("application-code");
        var applicationSettings = ub.funcs.getApplicationSettings(application_code);
        var container = $(this).closest(".layer-container");
        var layer_number = $(container).data("layer-number");
        var color_code = $(this).data("color-code");
        var color_object = ub.funcs.getColorByColorCode(color_code);

        $(container).find("a.uk-active").removeClass("uk-active").html("");

        ApplicationCore.funcs.changeApplicationPatternColor(applicationSettings, color_code, layer_number, function() {
            $(that).addClass("uk-active");
            $(that).html('<span class="fa fa-check fa-1x color-pallete-check" style="color: #'+ color_object.forecolor +'"></span>');
        });

        Pattern.core.changePatternPreviewColor(layer_number, color_code, function(image) {
            $(".application-container .application-color-settings-content").find("img.pattern-preview-src").prop("src", image);
        });
    },

    onSelectMascot: function() {
        var application_code = $(this).closest(".application-container").data("application-code");
        var applicationSettings = ub.funcs.getApplicationSettings(application_code);

        ub.data.isEditing = true;
        ub.data.newApplication = applicationSettings;

        ub.applicationMascotAsPattern = true;
        InksoftMascot.events.onShowStockMascot();
    },

    editPatternMascot: function() {
        var application_code = $(this).closest(".application-container").data("application-code");
        var applicationSettings = ub.funcs.getApplicationSettings(application_code);

        ub.data.isEditing = true;
        ub.applicationMascotAsPattern = true;

        if (typeof applicationSettings !== "undefined") {
            var design_id = applicationSettings.mascot_pattern.design_id;
            InksoftMascot.funcs.onShowEditDesignModal(design_id, applicationSettings.code, function() {
                UIkit.modal("#inksoft-design-editor-modal").show();
            });
        }
    },

    changePatternLayout: function() {
        var value = $(this).val();
        var application_code = $(this).closest(".application-container").data("application-code");
        var applicationSettings = ub.funcs.getApplicationSettings(application_code);
        // Change layout
        PatternMascot.core.changeLayout(applicationSettings, value);

        // Change layout of the matching application
        var matching = ub.data.matchingIDs.getMatchingID(applicationSettings.code);
        if (typeof matching !== "undefined") {
            var _matchingSettingsObject = _.find(ub.current_material.settings.applications, {code: matching.toString()});
            PatternMascot.core.changeLayout(_matchingSettingsObject, value);
        }
    }
}


TextApplication.render = function(application_id) {
    ub.funcs.deactivatePanels();
    var applicationSettings = ub.funcs.getApplicationSettings(application_id);

    if (typeof applicationSettings !== "undefined") {
        // Check if has pattern mascot
        if (PatternMascot.utilities.hasMascot(application_id)) {
            var embellishment = applicationSettings.mascot_pattern.design_details;
            // Check if has conflicting colors
            if (ub.funcs.hasConflict(embellishment)._hasConflict) {
                TextApplication.renderConflictColors(applicationSettings);
            } else {
                TextApplication.renderTextApplication(applicationSettings.code)
            }
        } else {
           TextApplication.renderTextApplication(applicationSettings.code)
        }       
    } else {
        ub.utilities.warn("Cannot find application setting of code " + application_id);
    }

    // Bind Text Application Events
    TextApplication.events.init();
    ApplicationCore.funcs.afterRender(applicationSettings);
}

TextApplication.renderConflictColors = function(applicationSettings) {
    var tmpl = _.template($("#mascot-pattern-conflict-colors").html());
    var embellishment = applicationSettings.mascot_pattern.design_details;

    if (typeof embellishment !== "undefined") {
        $(".modifier_main_container").append(tmpl({
            application: applicationSettings,
            conflictingColors: ub.funcs.hasConflict(embellishment)._conflictColors,
            type: applicationSettings.application_type.toTitleCase()
        }));
    }
}

TextApplication.renderTextApplication = function(application_id) {
    var tmpl = _.template($("#text-application-template").html());
    var utilities = ApplicationCore.utilities;
    var applicationSettings = ub.funcs.getApplicationSettings(application_id);
    var blockPatternMD = ['Stock NL6010', '2023 Top Next Level 6010 Triblend', 'Lite'];
    var colorsRule = ub.current_material.material.rule;
    var stockFactoryCode = ['HCM', 'QTS', 'MDJ'];

    $(".modifier_main_container").append(tmpl({
        application: applicationSettings,
        colors: ub.current_material.settings.team_colors,
        scale: utilities.computeScale(applicationSettings),
        position: utilities.computePosition(applicationSettings),
        angle: utilities.computeRotation(applicationSettings),
        isSpecial: _.contains(ub.fontGuideIDs, window.ub.valid),
        colorsRule: colorsRule !== undefined ? ub.current_material.material.rule.sublimated_colors : ub.current_material.settings.team_colors,
        blockPatternMD: _.contains(blockPatternMD, ub.config.blockPattern),
    }));

    // if (_.contains(blockPatternMD, ub.config.blockPattern)) {
    //     $('a.palette-color-MD[data-color-code="DN"]').remove();
    //     $('a.palette-color-MD[data-color-name="Gray"]').attr('data-color-name', 'Detroit Gray');
    // }
    
    if (_.contains(stockFactoryCode, ub.current_material.material.factory_code)) {
        $('div#edit-team-colors').removeClass('uk-hidden');
    }

}